const servicesData = [
  {
    id: "1",
    title: "Matchmaking Service",
    description:
      "Encouraging individuals to ask questions entails fostering a culture of clarity and precision, steering away from vague or ambiguous statements. For instance, a well-articulated inquiry might involve seeking guidance on a specific event, such as determining the optimal timing for a knee surgery. By emphasizing the importance of precision in questioning, individuals can ensure that the responses they receive are equally detailed and insightful, ultimately leading to more informed decisions and actions.",
    imageurl:
      "https://www.horoscope.com/wp-content/uploads/sites/2/2020/08/matchmaking-768x512.jpg",
  },
  {
    id: "2",
    title: "Matchmaking Service2",
    description:
      "Encouraging individuals to ask questions entails fostering a culture of clarity and precision, steering away from vague or ambiguous statements. For instance, a well-articulated inquiry might involve seeking guidance on a specific event, such as determining the optimal timing for a knee surgery. By emphasizing the importance of precision in questioning, individuals can ensure that the responses they receive are equally detailed and insightful, ultimately leading to more informed decisions and actions.",
    imageurl:
      "https://www.horoscope.com/wp-content/uploads/sites/2/2020/08/matchmaking-768x512.jpg",
  },
  {
    id: "3",
    title: "Matchmaking Service3",
    description:
      "Encouraging individuals to ask questions entails fostering a culture of clarity and precision, steering away from vague or ambiguous statements. For instance, a well-articulated inquiry might involve seeking guidance on a specific event, such as determining the optimal timing for a knee surgery. By emphasizing the importance of precision in questioning, individuals can ensure that the responses they receive are equally detailed and insightful, ultimately leading to more informed decisions and actions.",
    imageurl:
      "https://www.horoscope.com/wp-content/uploads/sites/2/2020/08/matchmaking-768x512.jpg",
  },
  {
    id: "4",
    title: "Matchmaking Service4",
    description:
      "Encouraging individuals to ask questions entails fostering a culture of clarity and precision, steering away from vague or ambiguous statements. For instance, a well-articulated inquiry might involve seeking guidance on a specific event, such as determining the optimal timing for a knee surgery. By emphasizing the importance of precision in questioning, individuals can ensure that the responses they receive are equally detailed and insightful, ultimately leading to more informed decisions and actions.",
    imageurl:
      "https://www.horoscope.com/wp-content/uploads/sites/2/2020/08/matchmaking-768x512.jpg",
  },
];

export default servicesData;
